export var SidepanelTypes;
(function (SidepanelTypes) {
  SidepanelTypes["TEMPLATE"] = "TEMPLATE";
  SidepanelTypes["CONTACT"] = "CONTACT";
  SidepanelTypes["RIGHTBAR"] = "RIGHTBAR";
  SidepanelTypes["ROUTER"] = "ROUTER";
  SidepanelTypes["CARD"] = "CARD";
  SidepanelTypes["FOOTER"] = "FOOTER";
})(SidepanelTypes || (SidepanelTypes = {}));
